export default class CopyShareText {
    constructor(holder) {
        if (!holder) {
            return
        }

        this.holder = holder
        this.attachEvents()
    }

    attachEvents() {
        const shareBtn = this.holder.querySelector('.opener')
        const shareInput = this.holder.querySelector('.js-copy-share-text-input')
        const url = window.location.href
        const sharedLink = `<iframe src='${url}' width='100%' height='600' style='display:table; max-width:880px; margin:auto; width:800px;' frameBorder='0' scrolling='yes'></iframe>`

        shareInput.value = sharedLink

        shareBtn.addEventListener('click', (e) => {
            e.preventDefault()

            shareInput.select()
            document.execCommand('copy')
            this.holder.classList.add('active')

            setTimeout(() => {
                this.holder.classList.remove('active')
            }, 1500)
        })
    }
}
